import { LeadTimeStrategy } from '@snap-types/models/enums';

export const leadTimeConfigTypesForSite: Record<string, LeadTimeStrategy[]> = {
  raf: [
    LeadTimeStrategy.CONSTANT_VALUE,
    LeadTimeStrategy.PLANNING_LEADTIME,
    LeadTimeStrategy.RAF_FIXED_MARKET,
  ],
  default: [
    LeadTimeStrategy.CONSTANT_VALUE,
    LeadTimeStrategy.PLANNING_LEADTIME,
  ],
};

export const leadTimeConfigOptions = {
  [LeadTimeStrategy.CONSTANT_VALUE]: 'Constant Value',
  [LeadTimeStrategy.PLANNING_LEADTIME]: 'Planning Lead Time',
  [LeadTimeStrategy.RAF_FIXED_MARKET]: 'Fixed Market',
} as const satisfies Record<LeadTimeStrategy, string>;

export function getAvailableLeadTimeConfigTypes(
  siteCode: string,
  existingTypes: LeadTimeStrategy[] = [],
): { all: LeadTimeStrategy[]; available: LeadTimeStrategy[] } {
  const siteAvailableTypes =
    leadTimeConfigTypesForSite[siteCode.toLowerCase()] ??
    leadTimeConfigTypesForSite.default;

  return {
    all: siteAvailableTypes,
    available: siteAvailableTypes.filter(
      (type) => !existingTypes.includes(type),
    ),
  };
}
